import type { ROLES } from "containers/ScopeContext/roles.enum";
import { TinyBody } from "helpers/TypographyComponents";

interface IRolePreview {
    /**
     * Role
     */
    role: ROLES;
    /**
     * Role label
     */
    label: string;
}
/**
 * Render current infos of the preview role
 * @returns
 */
const RolePreview = ({ role, label }: IRolePreview) => {
    return (
        <div
            style={{
                backgroundColor: "#F6F4FC",
                paddingInline: "0.5rem",
                paddingBlock: "0.25rem",
                marginTop: "0.5rem",
            }}
        >
            <TinyBody style={{ color: "#6c5bbe", fontWeight: 500 }}>{label}</TinyBody>
            <TinyBody style={{ color: "#6c5bbe" }}>Vue du rôle : {role}</TinyBody>
        </div>
    );
};

export default RolePreview;
